/**
 * @format
 */
import { SELECT_UNSELECT_DEAL } from '../actions';

export default (dealId, checked, shouldClearAll = false) => ({
  type: SELECT_UNSELECT_DEAL,
  payload: { dealId, checked, shouldClearAll },
});
